import React from 'react';
import { Editor } from '@tiptap/react';
import Box from '@mui/material/Box';

import { useToolbarState } from './useToolbarState';
import AIInputSection from './AIInputSection';
import CommentInputSection from './CommentInputSection';
import MainToolbarSection from './MainToolbarSection';
import AIActionsSection from './AIActionsSection';

const ToolbarContent: React.FC<{
  editor: Editor;
  onClose: () => void;
}> = ({ editor, onClose }): React.ReactNode => {
  if (!editor) {
    return null;
  }

  const {
    displayCommentInput,
    addComment,
    handleAddComment,
    displayAiInput,
    aiInput,
    setAiInput,
    handleAskAI,
    handleGenerate,
    anyAIActions,
    isGenerating,
    hasPending,
  } = useToolbarState({ editor, onClose });

  if (displayAiInput) {
    return (
      <AIInputSection
        aiInput={aiInput}
        setAiInput={setAiInput}
        onGenerate={handleGenerate}
        isGenerating={isGenerating}
        hasPending={hasPending}
      />
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center', margin: '4px' }}>
      {displayCommentInput && <CommentInputSection onAddComment={handleAddComment} />}
      {!anyAIActions && !displayCommentInput && (
        <MainToolbarSection
          editor={editor}
          onAddComment={addComment}
          onAskAI={handleAskAI}
          isGenerating={isGenerating}
        />
      )}
      <AIActionsSection editor={editor} isGenerating={isGenerating} />
    </Box>
  );
};

export default ToolbarContent;
